module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre3"
  }, [_vm._v("Dramatis Personae")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bischof Konrad von Würzburg")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Rotenhahn")]), _vm._v(", Hofmeister\ndes Bischofs")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Markgraf Friedrich")]), _vm._v(", Oberster\nHauptmann der Besatzung von »Unserer Frauen Berg«")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Lichtenstein")]), _vm._v(", Domherr")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Ritter:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Heinz von Stein")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Hanstein")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans von Grumbach")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian von Geyer")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wolf von Kastell")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lorenz von Hutten")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kunz von der Mühlen")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gilgenessig")]), _vm._v(", Schreiber")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Florian Geyer")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Stephan von Menzingen")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Götz von Berlichingen")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Thomas von Hartheim")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Georg von Wertheim")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wilhelm von Grumbach")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Anna von Grumbach")]), _vm._v(", seine Frau")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Tellermann")]), _vm._v(", Feldhauptmann des\nFlorian Geyer")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Karlstatt")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Rektor Besenmeyer")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Schultheiß Bezold von\nOchsenfurt")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Lorenz Löffelholz")]), _vm._v(", Feldschreiber\ndes Florian Geyer")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Martin")]), _vm._v(", ein fahrender Schüler")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Boten:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Finkenmäuslin")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kunzlin")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sartorius")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bermetter")]), _vm._v(", genannt "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Link")]), _vm._v(", ein Würzburger")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Bauernführer:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Jacob Kohl")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Pfarrer Bubenleben")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Wendel Hippler")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Georg Metzler")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Flammenbecker")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kratzer")]), _vm._v(", Wirt")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Erster Bauernhauptmann")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Zweiter Bauernhauptmann")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Dritter Bauernhauptmann")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Schäferhans")]), _vm._v(" "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page4",
      "title": "lac/MEsswein"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Marei")]), _vm._v(", Lagerdirne")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ein Trunkener")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ein Dudelsackpfeifer")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Jörg Kumpf")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Bürger von Rothenburg:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kilian")]), _vm._v(", der Harnischweber"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Jos Frankenheim")]), _vm._v(", Schulmeister"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Oswald Barchart")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ochsenhans")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Markart Töppelin")]), _vm._v(", genannt\nBohnlein"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Engelhart Goppolt")]), _vm._v(", Leinenweber"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans Kunrat")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hans Beheim")]), _vm._v(", Maurer"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "speaker"
  }, [_vm._v("Christheinz")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Weitere Bürger von Rothenburg")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Entlaufener Mönch")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Hausierer")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Jöslein")]), _vm._v(", ein alter Jude")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Eine alte Frau")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ein zerlumpter Mensch")]), _vm._v(", ihr Sohn")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Kläuslin")]), _vm._v(", fahrender Musikant")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sein Weib")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sebastian Schertlin")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Feistle")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ursel")]), _vm._v(", Beschließerin in Grumbachs\nSchloß")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Peter")]), _vm._v(", ein Reitknecht")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ein Weinsberger")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der blinde Mönch")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ein Höriger")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ein Bauer")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Die Kellnerin")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Erster Reisiger")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Zweiter Reisiger")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Bauern")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Eine Bäuerin")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ritter")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Erster Ritter")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Zweiter Ritter")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Erster Domherr")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Domherr")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Trabant")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Gefolge des Bischofs, Ritter, Trabanten,\nBauern, Musikanten, Volk.")]), _vm._v(" "), _c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre3 pcalibre2",
    attrs: {
      "id": "page5",
      "title": "lac/MEsswein"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0